var LocationScheduleModel = function(){

};
